export const upcomingAssignments = [
  { id: 1, title: "Quantum Mechanics P-Set", course: "PHYS 401", due: "Today, 11:59 PM", type: "assignment", progress: 75, priority: 'high' },
  { id: 2, title: "Neural Networks Midterm", course: "CS 450", due: "Tomorrow, 9:00 AM", type: "exam", progress: 40, priority: 'critical' },
  { id: 3, title: "Modern Lit Essay", course: "ENG 302", due: "In 3 days", type: "project", progress: 10, priority: 'medium' },
  { id: 4, title: "Lab Report: Spectroscopy", course: "CHEM 210", due: "In 5 days", type: "assignment", progress: 90, priority: 'low' },
  { id: 5, title: "Discrete Math Quiz", course: "MATH 220", due: "In 6 days", type: "exam", progress: 0, priority: 'high' },
];

export const courses = [
  { id: "c1", code: "PHYS 401", name: "Quantum Mechanics", gradeGoal: "A", currentGrade: 92, instructor: "Dr. Feynman", days: "Mon, Wed" },
  { id: "c2", code: "CS 450", name: "Deep Learning", gradeGoal: "A", currentGrade: 88, instructor: "Prof. Hinton", days: "Tue, Thu" },
  { id: "c3", code: "ENG 302", name: "Modern Literature", gradeGoal: "B+", currentGrade: 85, instructor: "Dr. Woolf", days: "Fri" },
  { id: "c4", code: "MATH 220", name: "Discrete Structures", gradeGoal: "A-", currentGrade: 94, instructor: "Dr. Lovelace", days: "Mon, Wed" },
];

export const flashcardDecks = [
  { id: "d1", title: "CS450: Backpropagation", count: 42, lastStudied: "2 hrs ago", mastery: 65 },
  { id: "d2", title: "PHYS401: Schrödinger Eq", count: 18, lastStudied: "1 day ago", mastery: 88 },
  { id: "d3", title: "Spanish Vocab: Chapter 4", count: 105, lastStudied: "3 days ago", mastery: 42 },
];

export const sampleCards = [
  { id: "f1", front: "What is the primary purpose of an activation function in a neural network?", back: "To introduce non-linearity into the output of a neuron." },
  { id: "f2", front: "Define the chain rule in the context of backpropagation.", back: "It calculates the derivative of composite functions, allowing the error to be distributed back through the network layers." },
  { id: "f3", front: "What is vanishing gradient?", back: "When gradients become extremely small during backpropagation, preventing weights from updating effectively in deep networks." }
];

export const projectMilestones = [
  { id: "m1", title: "Literature Review", status: "completed", date: "Oct 12" },
  { id: "m2", title: "Data Collection", status: "in-progress", date: "Oct 25" },
  { id: "m3", title: "Model Training", status: "pending", date: "Nov 05" },
  { id: "m4", title: "Final Report", status: "pending", date: "Nov 20" },
];